import React from 'react'
import { Table as TableCore } from 'react-bootstrap'
import { useWindowSize } from 'react-use'
import isNumber from 'lodash/isNumber'
import isObject from 'lodash/isObject'
import type { DynamicTableHeight, TableLayoutProps } from './types'
import { useLoadMoreOnScroll } from '@ztechapps/common.hook'
import { Scrollable } from '@ztechapps/webui.util'
import { useTableContext } from './Context'
import styles from './datatable.module.scss'

export const Layout = ({ children, responsive, ...props }: TableLayoutProps) => {
  const { height, listResult } = useTableContext()
  const { scrollRef } = useLoadMoreOnScroll(listResult)
  const { height: windowHeight } = useWindowSize()

  // A margin pair resolves against the window height; a number or CSS length passes through
  // untouched.
  let tableHeight: number | string | undefined
  if (isObject(height) && isNumber((height as DynamicTableHeight)?.topMargin)) {
    const margins = height as DynamicTableHeight
    tableHeight = windowHeight - (margins.topMargin ?? 0) - (margins.bottomMargin ?? 0)
  } else {
    tableHeight = height as number | string | undefined
  }

  // A heightless caller must not inherit Scrollable's '100vh' default, which would pin an
  // embedded table to the viewport instead of letting it grow with its page region.
  const scrollableHeight = tableHeight ?? 'none'

  return (
    <Scrollable
      ref={scrollRef}
      className={`${styles.fixedTableHeadFoot} position-relative ${responsive ? 'table-responsive' : ''} border-top border-bottom`}
      height={scrollableHeight}
    >
      <TableCore {...props}>{children}</TableCore>
    </Scrollable>
  )
}
